module.exports = __webpack_public_path__ + "img/OMNI-alt.8aaae641.svg";